export default __webpack_public_path__ + "static/media/zoho-crm-icon.05b7b6e3.png";